import { useEffect, useState } from "react";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../Interfaces/base/IResponse";
import { IPanelEditarElemento } from "./PanelEditarElemento";
import { IEditElemento } from "../../../../../Interfaces/hazard/IHazard";
import { ElementoEstandarService } from "../../../../../services/hazard/elementoEstandarService";

export const UsePanelEditarElemento=(props:IPanelEditarElemento)=>{
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const initial:IEditElemento={
        nombreEstandar: "",
        elementoEstandarId: "",
    }
    const reset=()=>{
        setMensaje("")
        setRequest(initial)
        setStatus(0)
        props.onDismiss()
    }
    const [request,setRequest]=useState<IEditElemento>(initial)
    useEffect(()=>{
        if(props.isOpen){
          setRequest({...request,nombreEstandar:props.item.nombreElementoEstandar,elementoEstandarId:props.item.elementoEstandarId})
          }
    },[props.isOpen])
    const putEditarElemento=()=>{
        setLoading(true)
        ElementoEstandarService.EditarElemento(request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                    props.reload?.();
                    reset()
                },3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
           
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
    return {request,setRequest,putEditarElemento,loading,reset,mensaje,status}
}